<template>
    <v-card v-if="!loading">
        <v-data-table 
            :items="items" 
            :items-per-page="10" 
            :footer-props="{'items-per-page-options': [10, 50, 100, 200, -1]}"
            :headers="headers"
            :search="search"
            :custom-filter="customSearch"> 
            <template v-slot:item="props">
                <tr>
                    <td>{{ props.item.landtaal_oms }}</td>
                    <td>{{ props.item.regi_code }}</td>
                    <td>{{ props.item.regi_oms }}</td>
                    <td>{{ props.item.regi_noordoost_lat }}</td>
                    <td>{{ props.item.regi_noordoost_lng }}</td>
                    <td>{{ props.item.regi_zuidwest_lat }}</td>
                    <td>{{ props.item.regi_zuidwest_lng }}</td>
                </tr>
            </template>
        </v-data-table>
    </v-card>
</template>

<script>

    export default {
        components: {

        },
        props: {
        },    
        data() {
            return { 
                loading: true,

                search: "",
                country: "",

                headers: [
                    { text: "Country", value: "landtaal_oms", width: "10%" },
                    { text: "Ski area code", value: "regi_code", width: "10%" },
                    { text: "Description", value: "regi_oms", width: "20%" },
                    { text: "North east latitude", value: "regi_noordoost_lat", width: "10%" },
                    { text: "North east longitude", value: "regi_noordoost_lng", width: "10%" },
                    { text: "South west latitude", value: "regi_zuidwest_lat", width: "10%" },
                    { text: "South west longitude", value: "regi_noordoost_lng", width: "10%" },
                ],

                items: [],
                allitems: [],
            }
        },  
        mounted() {
            this.listSkrg();
        },
        methods: {
            customSearch (value, search, item) {
                return Object.values(item).some(v=>v&&v.toString().toLowerCase().includes(search.toLowerCase()))
            },
            listSkrg() {
                this.loading = true;
                this.$axios.post("ares/json/ares/syst/skrg/getLandRegi.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "getLandRegi"
                    },
                    getLandRegi: {
                        regi_type: "ski",
                    }
                }).then(res => {
                    if (res.data.error) {
                        // console.log(res.data.error);
                        this.$store.dispatch("setSnackbar", {
                            showing: true,
                            text: res.data.error.message,
                            color: "error"
                        });
                    } else {
                        this.allitems = [];
                        this.items = [];
                        for(let iIndex1=0;iIndex1<res.data.getLandRegi.length;iIndex1++) {
                            for(let iIndex2=0;iIndex2<res.data.getLandRegi[iIndex1].regions.length;iIndex2++) {
                                let item = {
                                    land_code: res.data.getLandRegi[iIndex1].land_code,
                                    landtaal_oms: res.data.getLandRegi[iIndex1].landtaal_oms,
                                    regi_code: res.data.getLandRegi[iIndex1].regions[iIndex2].regi_code,
                                    regi_oms: res.data.getLandRegi[iIndex1].regions[iIndex2].regi_oms,
                                    regi_noordoost_lat: res.data.getLandRegi[iIndex1].regions[iIndex2].regi_noordoost_lat,
                                    regi_noordoost_lng: res.data.getLandRegi[iIndex1].regions[iIndex2].regi_noordoost_lng,
                                    regi_zuidwest_lat: res.data.getLandRegi[iIndex1].regions[iIndex2].regi_zuidwest_lat,
                                    regi_zuidwest_lng: res.data.getLandRegi[iIndex1].regions[iIndex2].regi_zuidwest_lng,
                                };
                                this.allitems.push(item);
                                this.items.push(item);
                            }
                        }
                        // this.allitems = res.data.getLandRegi;
                        // this.items = res.data.getLandRegi;
                        this.loading = false;
                    }
                });
            },
            updateSelection(selectionType, selectionValue) {
                // console.log(selectionType);
                // console.log(selectionValue);
                switch (selectionType) {
                    case "refresh":
                        this.listSkrg();
                        break;
                    case "search":
                        this.search = selectionValue;
                        break;
                    case "country":
                        this.country = selectionValue;
                        this.filterAll();
                        break;                
                    default:
                        break;
                }
            },
            filterAll() {
                this.items = [];
                for (let iIndex=0; iIndex<this.allitems.length; iIndex++) {
                    let ok = true;
                    if (!this.allitems[iIndex].land_code.includes(this.country)) {
                        ok = false;
                    }
                    if (ok) {
                        this.items.push(this.allitems[iIndex]);
                    }
                } 
            },
        }
    }
</script>

<style scoped> 
    .avatar {
        cursor: pointer;
    }
</style>